<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="con" title="Contents">
<p class="h2a">Contents</p>
<p class="toc"><a href="#/text/Chapter01#ach01">A Meal in Winter</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?95d360b4